import { render, staticRenderFns } from "./MerchantInformation.vue?vue&type=template&id=2d54879f&scoped=true&"
import script from "./MerchantInformation.vue?vue&type=script&lang=js&"
export * from "./MerchantInformation.vue?vue&type=script&lang=js&"
import style0 from "./MerchantInformation.vue?vue&type=style&index=0&id=2d54879f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d54879f",
  null
  
)

export default component.exports